export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <div className="relative rounded-2xl overflow-hidden bg-background-200/50 border border-background-300/40">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20anime%20watching%20room%20with%20large%20screen%20displaying%20colorful%20anime%20scene%20cherry%20blossom%20decorations%20soft%20warm%20lighting%20comfortable%20couch%20snacks%20friendly%20atmosphere%20modern%20interior%20with%20anime%20posters&width=1000&height=750&seq=about-sakura-anime&orientation=landscape"
                alt="樱花动漫之家品牌形象 - 温馨动漫追更体验"
                className="w-full h-auto object-cover aspect-[4/3]"
              />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
              关于樱花动漫
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              樱花动漫之家诞生于对动漫的热爱。我们是一个专注追更动漫的内容平台，致力于为动漫爱好者提供最新动漫新番的在线观看和追更服务。从连载动漫更新到热门新番推荐，我们覆盖了热血战斗、恋爱甜宠、异世界冒险、搞笑日常、悬疑推理和治愈温情等全类型番剧。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              我们相信每一部动漫都有独特的魅力，每一位追更者都值得最好的观看体验。樱花动漫之家持续更新、免费开放，让追更动漫成为你生活中最轻松的享受。
            </p>
            <div className="flex flex-wrap gap-4 justify-center lg:justify-start">
              <div className="flex items-center gap-2 text-xs text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-green-500"></span>
                每日更新 50+ 番剧
              </div>
              <div className="flex items-center gap-2 text-xs text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                覆盖 12 大分类
              </div>
              <div className="flex items-center gap-2 text-xs text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                完全免费开放
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}